// Third-Party
import { Box, useTheme } from "@mui/material";

// Internal
import Label from "@components/Label";

// Types
import { ICustomProperty } from "src/@types/documents/documentList";

interface ICatalogCustomPropertiesProps {
  customProperties?: ICustomProperty[] | null;
}

export const CatalogCustomProperties = ({
  customProperties,
}: ICatalogCustomPropertiesProps) => {
  const theme = useTheme();

  if (!customProperties?.length) return null;

  return (
    <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5, mt: 0.5 }}>
      {customProperties.map((property, index) => (
        <Label
          key={`${property.k}-${property.v}-${index}`}
          variant={theme.palette.mode === "light" ? "ghost" : "filled"}
          color="secondary"
          sx={{ textTransform: "capitalize" }}
        >{`${property.k} = ${property.v}`}</Label>
      ))}
    </Box>
  );
};
